export function DataSourceFootnote({generatedAt}: {generatedAt?: string}) {
    return (
        <p className="text-[10px] text-muted-foreground mt-2 italic">
            Source: Xero Profit & Loss report snapshots
            {generatedAt && ` | As of ${new Date(generatedAt).toLocaleDateString()}`}
        </p>
    );
}
